const initialState = () => {
  return {
    packages: [],
    insights: {
      insights: [],
      packages: []
    },
    packageInsights: {
      insights: [],
      package: {}
    },
    ignoredLastInsight: {},
    exploreInsightsFilter: {
      activeCollection: {},
      category: '',
      listingOption: "all",
      isActiveRemoveFilterBtn: false,
    },
    runningPackagesData: {},
    runnedPackages: [],
    isRunPackage: {},
    insightSearchText: '',
    searchedInsightsResults: [],
    weeklyInsightChanges: [],
    sortedInsights: []
  }
}


export default initialState



// WEBPACK FOOTER //
// ./src/store/modules/insights/initialState.js